module.exports = __webpack_public_path__ + "media/images/shapes/blurs/blur-4-b2130a56bedc11d3d81aba8ff077ff46c233ddf367ba3ea95d373442c53c8cbb.svg";